// Fallo de registrar el equipo y abrir su candado: el mensaje, el reintento cuando sirve y la salida
// cuando reintentar no lo arregla.
import { Button } from '@/kit';
import {
    deviceErrorBlamesImei,
    deviceErrorEnrollmentFailed,
    deviceErrorLocksImei,
    deviceErrorMessage,
    deviceErrorNeedsProduct,
    deviceErrorRetryHelps,
} from '../../deviceErrors';
import { InlineQueryError } from '../QueryErrorNotice';

export function DeviceRegisterError({
    error,
    onRetry,
    retrying,
    onBackToProduct,
}: {
    error: unknown;
    onRetry: () => void;
    retrying: boolean;
    onBackToProduct: () => void;
}) {
    const needsProduct = deviceErrorNeedsProduct(error);
    const imeiStuck = deviceErrorLocksImei(error) || deviceErrorBlamesImei(error);
    const retryable =
        !needsProduct &&
        !imeiStuck &&
        !deviceErrorEnrollmentFailed(error) &&
        deviceErrorRetryHelps(error);

    return (
        <>
            <InlineQueryError
                className="text-[12px]"
                message={deviceErrorMessage(error)}
                onRetry={retryable ? onRetry : undefined}
                retrying={retrying}
            />
            {/* El IMEI ya no se puede mover: reintentar no arregla nada. */}
            {imeiStuck && (
                <p className="text-[11.5px] leading-relaxed text-muted-foreground">
                    Si el IMEI registrado está equivocado, la única salida es cancelar la venta y
                    volver a levantarla.
                </p>
            )}
            {needsProduct && (
                <div className="flex justify-start">
                    <Button variant="outline" size="sm" onClick={onBackToProduct}>
                        Volver a elegir el equipo
                    </Button>
                </div>
            )}
        </>
    );
}
